const EVChargerChip = ({ label }: { label: string }) => {
  return (
    <div className="shrink-0 inline-block bg-gray10 px-[8px] rounded-[2px]">
      <span className="text-[12px] text-gray60 ">{label}</span>
    </div>
  )
}

export default EVChargerChip
